import React from "react";
import App from "../../app/App";
import LogoutContainer from "./LogoutContainer";

export default () => (
  <App>
    <LogoutContainer />
  </App>
);
